import VisibilityIcon from '@mui/icons-material/Visibility';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';

const ActionRenderer = ({ handleArchiveClick , handleViewCLick, showArchived}) => {

    return (
        <div style={{ display: "flex", gap: "8px" }}>
            {showArchived? null :<span
                style={{ cursor: "pointer", color: "#254a9a" }}
                onClick={handleViewCLick }
                tooltip="View Details"
            >
                  <VisibilityIcon /> 
            </span>}
            <span
                style={{ cursor: "pointer", color: "#254a9a" }}
                tooltip="Archive Protocol"
                onClick={handleArchiveClick}
            >
               {showArchived ?<UnarchiveOutlinedIcon/>: <ArchiveOutlinedIcon />}
            </span>
        </div>
    );
};

export default ActionRenderer;